import { createSvgIcon } from '@material-ui/core/utils';

export const MarketplaceCatalogIcon = createSvgIcon(
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.66976 2.33333H11.3302L14.6667 8.00303L11.3302 13.6667H4.66976L1.33334 8.00303L4.66976 2.33333ZM2.2866 8.00303L5.14021 12.8584H10.8598L13.7134 8.00303L10.8598 3.14155H5.14021L2.2866 8.00303ZM9.57229 10.6769L11.1507 8.00304L9.57229 5.32314H6.42775L4.84929 8.00304L6.42775 10.6769H9.57229Z" />
  </svg>,
  'MarketplaceCatalogIcon',
);
